export default __webpack_public_path__ + "db074fa22cf224af93d7b2122b1fab93.woff";